import type { Component } from "solid-js";
import { createSignal, getOwner, runWithOwner } from "solid-js";
import { useTranslation } from "../../state/i18n";
import { useCustomerState } from "../../state/customer";
import { TextAndIconButton } from "../../components/button/Button";
import { useClient } from "../../state/client";
import pMinDelay from "p-min-delay";
import { triggerBrowserDownload } from "../../utils/uploadUtil";
import { MINIMUM_ACTION_LOADING_DELAY } from "../../constants";

type FileDownloadButtonProps = { fileId: string };
export const FileDownloadButton: Component<FileDownloadButtonProps> = (props) => {
  const owner = getOwner();
  const { t } = useTranslation();
  const [downloading, setDownloading] = createSignal(false);
  const { customerId } = useCustomerState();

  return (
    <TextAndIconButton
      variant="secondary"
      size="medium"
      text={downloading() ? t(($) => $.DOWNLOAD_BUTTON_LOADING_LABEL) : t(($) => $.DOWNLOAD_BUTTON_LABEL)}
      icon="download"
      loading={downloading()}
      onClick={() => {
        const fileId = props.fileId;

        runWithOwner(owner, async () => {
          try {
            setDownloading(true);
            const client = useClient();
            const uri = `/api/v1.0/customers/${customerId}/registrationFile/${fileId}/download`;
            await pMinDelay(triggerBrowserDownload(client, uri), MINIMUM_ACTION_LOADING_DELAY);
          } finally {
            setDownloading(false);
          }
        });
      }}
    />
  );
};

export default FileDownloadButton;
